import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';
import { getProjectNameHeader } from '@/utils/imUtils';

const baseUrl = envConfig.formalServer + '/plat/admin/im/message/template/';

function baseApi() {

    function insert(data, projectName) {
        return Post(baseUrl + 'insertImMessageTemplate', data, getProjectNameHeader(projectName));
    }

    function deleteData(data, projectName) {
        return Post(baseUrl + 'deleteImMessageTemplate', data, getProjectNameHeader(projectName));
    }

    function update(data, projectName) {
        return Post(baseUrl + 'updateImMessageTemplate', data, getProjectNameHeader(projectName));
    }

    function query(data, projectName) {
        return Post(baseUrl + 'queryImMessageTemplate', data, getProjectNameHeader(projectName));
    }

    return {
        insert, deleteData, update, query
    };
}

export const imMessageTemplateApi = baseApi();
